var path = '/static/assets/khapps/fms_app/partials/includes/fms_navbar_filters.html';
var html = "<farm-filters ng-if=\"sub_app_page_id != 'farm_profile'\"></farm-filters>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;